import { IApiService } from '../interfaces/IApiService';
import { getEnvironment, configs } from '../../config/environment';
import { MockApiService } from '../MockApiService';
import { ProductionApiService } from '../ProductionApiService';

export class ServiceFactory {
  private static apiServiceInstance: IApiService | null = null;

  static createApiService(): IApiService {
    if (!this.apiServiceInstance) {
      const environment = getEnvironment();
      const envConfig = configs[environment];

      console.log(`ServiceFactory: Creating API service for environment: ${environment}`);
      console.log(`ServiceFactory: Mock data enabled: ${envConfig.mockDataEnabled}`);

      if (envConfig.mockDataEnabled) {
        console.log('ServiceFactory: Instantiating MockApiService');
        this.apiServiceInstance = new MockApiService();
      } else {
        console.log('ServiceFactory: Instantiating ProductionApiService');
        this.apiServiceInstance = new ProductionApiService();
      }
    }
    return this.apiServiceInstance;
  }

  static setApiService(service: IApiService): void {
    this.apiServiceInstance = service;
  }

  static resetService(): void {
    this.apiServiceInstance = null;
  }
}